import { connect } from 'react-redux';
import type { WWeddingView } from '@zola/svc-web-api-ts-client';
import { getWedding, RootState } from 'selectors/wedding';
import { getRegistryIsPublic } from 'selectors/registry/registrySelectors';
import WeddingDetails from './WeddingDetails';

type mapStateType = {
  weddingState: WWeddingView;
  registryIsPublic: boolean;
};

const mapStateToProps = (state: RootState): mapStateType => ({
  weddingState: getWedding(state),
  registryIsPublic: getRegistryIsPublic(state),
});

export default connect(mapStateToProps)(WeddingDetails);



// WEBPACK FOOTER //
// ./src/pages/settings/wedding/WeddingDetails/index.ts